export enum ApplicationType {
  IisApp = 1,
  WindowsTask = 2,
  WindowsService = 3,
  LinuxCron = 4,
}

export interface ApplicationDefinition {
  id: string;
  serverId: string;
  serverName: string;
  tenantId: string;
  tenantName: string;
  name: string;
  applicationType: ApplicationType;
  applicationTypeName: string;
  identifier: string; // JSON string
  healthRule: string; // JSON string
  expectedRunIntervalMinutes?: number;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
}

export interface CreateApplicationDefinitionRequest {
  serverId: string;
  tenantId: string;
  name: string;
  applicationType: ApplicationType;
  identifier: object; // JSON object
  healthRule: object; // JSON object
  expectedRunIntervalMinutes?: number;
}

export interface UpdateApplicationDefinitionRequest {
  id: string;
  serverId: string;
  tenantId: string;
  name: string;
  applicationType: ApplicationType;
  identifier: object; // JSON object
  healthRule: object; // JSON object
  expectedRunIntervalMinutes?: number;
}

// Identifier interfaces
export interface IisAppIdentifier {
  siteName: string;
  appPoolName: string;
  expectedSiteState: string;
  expectedAppPoolState: string;
  healthCheckUrl?: string;
  httpMethod?: string;
  httpStatusCodeExpected?: number;
  responseTimeThresholdMs?: number;
  timeoutMs?: number;
}

export interface WindowsTaskIdentifier {
  taskName: string;
  lastRunResultExpected?: string;
  shouldBeRunning?: boolean;
}

export interface WindowsServiceIdentifier {
  serviceName: string;
  expectedStatus: string;
  autoRestartEnabled?: boolean;
  restartAttemptCount?: number;
}

export interface LinuxCronIdentifier {
  jobName: string;
  schedule: string;
  lastExecutionStatusExpected?: string;
}

// HealthRule interfaces
export interface AppPoolRunningHealthRule {
  type: 'appPoolRunning';
}

export interface LastRunHealthRule {
  type: 'lastRun';
  maxDelayMinutes: number;
}

export interface ServiceRunningHealthRule {
  type: 'serviceRunning';
}

// Helper functions
export const applicationDefinitionHelper = {
  jsonToIdentifier: (json: string, applicationType: ApplicationType): any => {
    try {
      return JSON.parse(json);
    } catch {
      return {};
    }
  },
  identifierToJson: (identifier: any): string => {
    return JSON.stringify(identifier);
  },
  jsonToHealthRule: (json: string): any => {
    try {
      return JSON.parse(json);
    } catch {
      return {};
    }
  },
  healthRuleToJson: (healthRule: any): string => {
    return JSON.stringify(healthRule);
  },
};
